import { createFileRoute } from "@tanstack/react-router";
import { mcpConnectionLinkPageRoute } from "@/features/mcp-connections";

export const Route = createFileRoute("/kits/connect/$token")({
    ...mcpConnectionLinkPageRoute,
});
